import { Icon } from "@chakra-ui/react";
import React from "react";

const DownArrow = () => {
  return (
    <Icon
      width="12"
      height="3"
      viewBox="0 0 22 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1695 0L21.5 1.182L11 12L0.5 1.182L1.8305 0L11 9.447L20.1695 0Z"
        fill="#808080"
      />
    </Icon>
  );
};

export default DownArrow;
